import axios from "axios";
import axiosInstance from "./axiosInstance";

const apiUrl = process.env.REACT_APP_API_URL;

export const getUserByCodeApi = async (ucode, atoken) => {
  const response = await axiosInstance.get(`${apiUrl}/api/users/${ucode}/`);

  return response;
};

// edit cmp user for profile
export const editCmpUserApi = async (ucode, mydata) => {
  const response = await axiosInstance.put(
    `${apiUrl}/api/edit_company_user/${ucode}/`,
    mydata,
  );
  return response;
};

///// rishab code
export const fetchUsers = async (cmpid) => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/get_all_users/?companytransid=${cmpid}`,
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch users:", error);
    return [];
  }
};

export async function user_delete(uCode) {
  try {
    const response = await axiosInstance.delete(
      `${apiUrl}/api/delete_company_user/${uCode}/`,
      {},
    );
    return response.data;
  } catch (error) {
    console.error("Error during user delete API call:", error);
    throw error;
  }
}

/// komal code
export const addUser = async (userData) => {
  const response = await axiosInstance.post(
    `${apiUrl}/api/save-company-user/`,
    userData,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};

export async function getUserCode() {
  const response2 = await axiosInstance.get(
    `${apiUrl}/api/generate_user_code/`,
  );
  return response2;
}

//// rishabh code
export async function editUserApi(userCode, updatedData) {
  try {
    const response = await axiosInstance.put(
      `${apiUrl}/api/edit_company_user/${userCode}/`,
      updatedData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during user edit API call:", error);
    throw error;
  }
}
export const getRoles = async () => {
  const response = await axiosInstance.get(`${apiUrl}/api/get_roles/`);
  return response.data;
};

export const getAllCatSubcategoriesApi = async (companyId, userId) => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/user-project-mapping/?company_id=${companyId}&user_id=${userId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching categories & subcategories:", error);
    throw error;
  }
};

export const saveUserProjectMappingApi = async (payload) => {
  return await axiosInstance.post(
    `${apiUrl}/api/save-user-project-mapping/`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};